export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Point Attributes`
)});
  main.variable(observer("report")).define("report", ["html","title","attributes","dd"], function(html,title,attributes,dd){return(
html`${title()}
 <dl>
${attributes.map(dd)}
</dl>
`
)});
  main.variable(observer("viewof map")).define("viewof map", ["html","ol","rawCoords","pointProj","tileSource","mapUrl","pinSrc","invalidation"], function*(html,ol,rawCoords,pointProj,tileSource,mapUrl,pinSrc,invalidation)
{
  let div = html`<div style="height: 140px; width: 140px; background-color:#78ABCB !important;"/>`;
  yield div;
  const hdpi = true;
  let center = ol.proj.transform(rawCoords, pointProj, 'EPSG:2193');
  
  const pinFeature = new ol.Feature({
    geometry: new ol.geom.Point(center)
  });
  
  const res = 2240 * 6;
  
  pinFeature.setStyle();
  let map = new ol.Map({
    target: div,
    view: new ol.View({
      center: [1600000, 5500000],
      projection: 'EPSG:2193',
      resolutions: [res, 2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8],
      resolution: res
    }),
    controls: [],
    interactions: [],
    layers: [
      new ol.layer.Tile({
          source: tileSource({
          url: mapUrl,
          layerName:'topobasemap_notext',
          hdpi
        })
      }),
      new ol.layer.Tile({
        source: tileSource({
          url: mapUrl,
          layerName:'water_transport_text',
          hdpi
        })
      }),
      new ol.layer.Vector({
        style: new ol.style.Style({
            image: new ol.style.Icon({
            anchor: [0.5, 1.0],
			      src: pinSrc,
			      scale: 1 / 3,
			      size: [41, 64],
			      // opacity: 0.7
          })
        }),
        source: new ol.source.Vector({
          features: [pinFeature]
        })
      })
    ]
  });
  
  // map.getView().fit([686080, 4626400, 2513920, 6373600], map.getSize())
  
  invalidation.then(() => map.dispose());
  
  return new Promise(resolve => {
    map.once('rendercomplete', () => {
      div.dispatchEvent(new CustomEvent("input"));
      resolve(div);
    });
  }); 
}
);
  main.variable(observer("map")).define("map", ["Generators", "viewof map"], (G, _) => G.input(_));
  main.variable(observer("mapLoaded")).define("mapLoaded", ["map"], function(map)
{
  map;
  return true;
}
);
  main.variable(observer()).define(["html"], function(html){return(
html`<h3>Example subject</h3>`
)});
  main.variable(observer("pointSubject")).define("pointSubject", function()
{
  return {
    "id": 109,
    "kind": "custom",
    "geometryType": "Point",
    "featureCollection": {
      "type": "FeatureCollection",
      "features": [
        {
          "type": "Feature",
          "geometry": {
            "type": "Point",
            "coordinates": [
              1688736.1,
              5656112.6
            ]
          },
          "properties": {
            "pin": {
              "hidden": false,
              "checked": false,
              "data": {
                "x": 1688736.1,
                "y": 5656112.6,
                "title": "Pin at -39.23977, 174.02823",
                "id": null
              }
            },
            "hover": false
          }
        }
      ]
    },
    "title": "Pin at -39.23977, 174.02823",
    "sourceLayerId": 0,
    "srid": 2193,
    "member": 1
  };
}
);
  main.variable(observer()).define(["html"], function(html){return(
html`<h3>Implementation details</h3>`
)});
  main.variable(observer()).define(["md"], function(md){return(
md`Your linz api key:`
)});
  main.variable(observer("viewof linzKey")).define("viewof linzKey", ["html"], function(html){return(
html`<input type='text'/>`
)});
  main.variable(observer("linzKey")).define("linzKey", ["Generators", "viewof linzKey"], (G, _) => G.input(_));
  main.variable(observer("elevationQuery")).define("elevationQuery", ["linzKey","lonLat"], function(linzKey,lonLat)
{
  if (linzKey) {
   return fetch(`https://data.linz.govt.nz/services/query/v1/raster.json?key=${linzKey}&layer=51768&x=${lonLat[0]}&y=${lonLat[1]}`).then(resp => resp.json())
     .catch(e => { console.warn(e); return undefined});
  }
  return Promise.resolve(null)
}
);
  main.variable(observer("title")).define("title", ["pointSubject","html","DOM"], function(pointSubject,html,DOM){return(
() => {
  return pointSubject.title ? html`<h4>${DOM.text(pointSubject.title)}</h4>` : '';
}
)});
  main.variable(observer("elevation")).define("elevation", ["elevationQuery"], function(elevationQuery)
{
  try {
    return elevationQuery.rasterQuery.layers['51768'].bands[0].value;
  } catch(e) {
    return NaN;
  }
}
);
  main.variable(observer("elevationTxt")).define("elevationTxt", ["elevation"], function(elevation){return(
isNaN(elevation) ? 'unavailable' : `${Math.round(elevation)}m`
)});
  main.variable(observer("attributes")).define("attributes", ["dms","rawCoords","elevationTxt"], function(dms,rawCoords,elevationTxt)
{
  return [
    {
      name: 'Latitude Longitude',
      val: dms
    }, {
      name: 'NZTM Easting, Northing',
      val: (rawCoords || []).map(f => f.toFixed(0)).join(', ')
    }, {
      name: 'Elevation',
      val: elevationTxt
    }
  ];
}
);
  main.variable(observer("dd")).define("dd", ["html","DOM"], function(html,DOM){return(
(attr) => html`<dt>${DOM.text(attr.name)}</dt><dd>${DOM.text(attr.val)}</dd>`
)});
  main.variable(observer("rawCoords")).define("rawCoords", ["pointSubject"], function(pointSubject)
{
  let features = (pointSubject && pointSubject.featureCollection && pointSubject.featureCollection.features) || [];
  return features.length ? features[0].geometry.coordinates : null;
}
);
  main.variable(observer("pointProj")).define("pointProj", function(){return(
'EPSG:2193'
)});
  main.variable(observer("lonLat")).define("lonLat", ["rawCoords","ol","pointProj"], function(rawCoords,ol,pointProj)
{
  const [x, y] = rawCoords;
  return ol.proj.transform([x, y], pointProj, 'EPSG:4326')
}
);
  main.variable(observer("dms")).define("dms", ["ol","lonLat"], function(ol,lonLat){return(
ol.coordinate.toStringHDMS(lonLat)
)});
  main.variable(observer("mapUrl")).define("mapUrl", function(){return(
'https://portals-maps.landcareresearch.co.nz/mapcache/portals/wmts/?'
)});
  main.variable(observer("pin")).define("pin", ["html","pinSrc"], function(html,pinSrc)
{
  const img = html`<img src="${pinSrc}"/>`;
  return img
}
);
  main.variable(observer("tileSource")).define("tileSource", ["ol","defaultResolutions"], function(ol,defaultResolutions){return(
(options) => {
  let projExtent = [274000, 3087000, 3327000, 7173000];

  let tileGrid = new ol.tilegrid.WMTS({
    origin: ol.extent.getTopLeft(projExtent),
    extent: projExtent,
    resolutions: defaultResolutions,
    matrixIds: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16"]
  });

  let matrixSet = options.hdpi ? "NZTM2000HDPI" : "NZTM2000";
  return new ol.source.WMTS({
    tileGrid: tileGrid,
    projection: "EPSG:2193",
    url: options.url,
    format: 'jpeng',
    layer: options.layerName + (options.hdpi ? '-HDPI' : ''),
    style: 'default',
    tilePixelRatio: options.hdpi ? 2 : 1,
    matrixSet,
    // requestEncoding: "REST",
    attributions: options.attribution ? [options.attribution] : [],
  });
}
)});
  main.variable(observer("defaultResolutions")).define("defaultResolutions", function(){return(
[8960, 4480, 2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8, 1.4, 0.7, 0.28, 0.14, 0.07]
)});
  main.variable(observer("pinSrc")).define("pinSrc", function(){return(
"data:image/png;base64,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"
)});
  main.variable(observer()).define(["md"], function(md){return(
md`### Libraries`
)});
  main.variable(observer("olModules")).define("olModules", async function(){return(
{
  Map: (await import("https://unpkg.com/ol@6.5.0/Map.js?module")).default,
  source: {
    WMTS: (await import("https://unpkg.com/ol@6.5.0/source/WMTS.js?module")).default,
    Vector: (await import("https://unpkg.com/ol@6.5.0/source/Vector.js?module")).default
  },
  extent: (await import("https://unpkg.com/ol@6.5.0/extent?module")),
  tilegrid: {
    ...(await import("https://unpkg.com/ol@6.5.0/tilegrid?module")),
    WMTS: (await import("https://unpkg.com/ol@6.5.0/tilegrid/WMTS.js?module")).default
  },
  layer: {
    Tile: (await import("https://unpkg.com/ol@6.5.0/layer/Tile.js?module")).default,
    Vector: (await import("https://unpkg.com/ol@6.5.0/layer/Vector.js?module")).default,
  },
  format: {
      GeoJSON: (await import("https://unpkg.com/ol@6.5.0/format/GeoJSON.js?module")).default
  },
  coordinate: {
    ...(await import("https://unpkg.com/ol@6.5.0/coordinate?module")),
  },
  geom: {
    ...(await import("https://unpkg.com/ol@6.5.0/geom?module")),
  },
  style: {
    ...(await import("https://unpkg.com/ol@6.5.0/style?module")),
  },
  View: (await import("https://unpkg.com/ol@6.5.0/View.js?module")).default,
  Feature: (await import("https://unpkg.com/ol@6.5.0/Feature.js?module")).default,
  proj: {
    ...(await import("https://unpkg.com/ol@6.5.0/proj?module")),
    proj4: (await import("https://unpkg.com/ol@6.5.0/proj/proj4?module"))
  }  
}
)});
  main.variable(observer("ol")).define("ol", ["olModules","proj"], function(olModules,proj)
{
  // register the nztm projection with openlayers
  olModules.proj.proj4.register(proj);
  
  return olModules;
}
);
  main.variable(observer("proj")).define("proj", ["require","epsg2193"], async function(require,epsg2193)
{
  let proj = await require('proj4').catch(() => window.proj4);
  proj.defs("EPSG:2193", epsg2193);
  
  
  
  return proj;
}
);
  main.variable(observer("epsg2193")).define("epsg2193", function(){return(
"+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu"
)});
  main.variable(observer("css")).define("css", ["html"], function(html){return(
html`<link rel="stylesheet" href="https://unpkg.com/ol@6.5.0/ol.css">`
)});
  return main;
}
